// extracted by mini-css-extract-plugin
export default {"babyNav":"babyNav__P224Y"};